/**
 * OfficeSearch JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class OfficeSearch
 */
class OfficeSearch {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
        this.handleClickOutside = this.handleClickOutside.bind( this );
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {

    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.searchInput = $( '#js-office-search' );
        this.searchBtn = $( '#js-office-search-btn' );
        this.results = $( '#js-office-search-result' );
        this.dropdown = $( '#js-office-search-result-wrapper' );
        this.spinner = $( '#js-office-search-spinner' );
    }

    /**
     *  This gets search results
     *
     */
    getResults( searchstring ) {

        // Empty possible old results, show spinner and dropdown and save current value
        this.results.empty();
        this.spinner.addClass( 'office-search__spinner--visible' );
        this.dropdown.addClass( 'office-search__result-wrapper--visible' );
        this.currentSearchValue = searchstring;

        dp( 'PageContact/GetOffices', {
            partial: 'officesearchresult',
            'args': {
                searchstring
            }
        }).then( data => {

            // Hide spinner and show data rendered with dust partial
            this.spinner.removeClass( 'office-search__spinner--visible' );
            this.results.html( data.success );
            window.addEventListener( 'click', this.handleClickOutside );
        }).catch( error => {
            this.spinner.removeClass( 'office-search__spinner--visible' );
            this.results.html( '<div class="office-search__error"><p>Haku ei onnistunut</p></div>' );
            console.log( error );
        });
    }

    /**
     *  This handles closing the search result modal, if it is opened
     * @param {*} e
     */
    handleClickOutside( e ) {
        if ( $( e.target ).closest( this.results ).length === 0 ) {
            this.dropdown.removeClass( 'office-search__result-wrapper--visible' );
            window.removeEventListener( 'click', this.handleClickOutside );
        }
    }


    /**
     * Register event listener for search input and button
     */
    registerHandler() {
        this.searchInput.keypress( ( e ) => {

            if ( e.which == 13 ) {
                this.getResults( e.target.value );
            }
        });

        this.searchBtn.on( 'click', ( e ) => {
            this.getResults( this.searchInput.val() );
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.registerHandler();
    }
}

// Export the class reference.
module.exports = OfficeSearch;



// WEBPACK FOOTER //
// ./assets/scripts/officesearch.js